import { gql } from '@apollo/client';

export const ADMINUSERTEXT_MUTATION = gql`
    mutation createOneAdminUserText($data: AdminUserTextCreateInput!) {
        createOneAdminUserText(data: $data) {
            adminUserTextId
        }
    }
`;

export const ADMINUSERTEXT_QUERY = gql`
    query findManyAdminUserText($where: AdminUserTextWhereInput) {
        findManyAdminUserText(where: $where, orderBy: { createdAt: desc }, take: 1) {
            adminUserTextId
            creator {
                name
            }
            text
            createdAt
        }
    }
`;
